import { render, staticRenderFns } from "./deviceType.vue?vue&type=template&id=b8b28720&scoped=true&"
import script from "./deviceType.vue?vue&type=script&lang=js&"
export * from "./deviceType.vue?vue&type=script&lang=js&"
import style0 from "./deviceType.vue?vue&type=style&index=0&id=b8b28720&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b28720",
  null
  
)

export default component.exports